import { services } from "onearm";
import { BaseGameState } from "onearm";

export default class PreloaderState extends BaseGameState {
    enter() {
        services.get("resources").load(["Fonts", "main","sounds"], {
            onLoaded: this.onLoaderComplete.bind(this),
            onProgress: this.onLoaderProgress.bind(this),
        });
        this.scene = this.scenes.add("PreloaderScene");
        this.scene.show("PreloaderScene");
    }

    onLoaderComplete() {
        this.owner.goTo("GameIntroState");
    }

    onLoaderProgress(progress) {
        if (this.scene) {
            this.scene.setProgress(progress * 100);
        }
    }

    exit() {
        super.exit();
        this.scenes.remove("PreloaderScene");
        this.scene = null;

        if (this.data.isMusicMuted) {
            this.audio.muteMusic(true);
        }

        if (this.data.isAmbientMuted) {
            this.audio.muteSfx(true);
        }

        this.audio.setVolumeMusic(this.data.musicVolume);
        this.audio.setVolumeSfx(this.data.sfxVolume);
        this.audio.setAllVolume(this.data.volume);
    }
}
